
import { strings } from '@/strings'

export default {
  name: 'HeroImage',
  setup () {
    return { strings }
  }
}
